<template>
  <v-container fluid>
    <TitleParagraphRow :value="value" dense />

    <v-row>
      <v-col>
        <OccasionList
          :filters-value="filtersData"
          :limit="3"
          :show-all-button="false"
          hide-details
          hide-info-button
          hide-share-button
          register-as-link
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col align="center">
        <v-btn
          :append-icon="mdiArrowRight"
          :href="`${canonicalPaths.base}${fullScheduleHref}`"
          color="secondary"
          target="_blank"
          variant="text"
        >
          View Full Schedule
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import {
  FILTER_DELIVERY_METHOD_ALL,
  FILTER_WHAT_ALL,
  FILTER_WHEN_UPCOMING,
  FILTER_WHO_ALL
} from '#root/lib/consts'
import { usePageContext } from '#root/renderer/usePageContext'
import { mdiArrowRight } from '@mdi/js'

const FILTERS_VALUE_DEFAULT = {
  deliveryMethod: FILTER_DELIVERY_METHOD_ALL,
  what: FILTER_WHAT_ALL,
  when: FILTER_WHEN_UPCOMING,
  who: FILTER_WHO_ALL
}

const props = defineProps({
  filters: {
    default: undefined,
    type: Object
  },
  filtersValue: {
    default: undefined,
    type: Object
  },
  fullScheduleHref: {
    default: '/training/schedule',
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})

const { canonicalPaths } = usePageContext()
const filtersData = ref(null)

onMounted(async () => {
  filtersData.value = Object.assign(
    {},
    FILTERS_VALUE_DEFAULT,
    props.filtersValue
  )
})
</script>
